/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  MintUserSessionRequestBody,
  MintUserSessionRequestBody$Outbound,
  MintUserSessionRequestBody$outboundSchema,
} from "../components/mintusersessionrequestbody.js";

export type MintUserSessionSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type MintUserSessionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  mintUserSessionRequestBody: MintUserSessionRequestBody;
};

/** @internal */
export type MintUserSessionSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const MintUserSessionSecurity$outboundSchema: z.ZodMiniType<
  MintUserSessionSecurity$Outbound,
  MintUserSessionSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function mintUserSessionSecurityToJSON(
  mintUserSessionSecurity: MintUserSessionSecurity,
): string {
  return JSON.stringify(
    MintUserSessionSecurity$outboundSchema.parse(mintUserSessionSecurity),
  );
}

/** @internal */
export type MintUserSessionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  MintUserSessionRequestBody: MintUserSessionRequestBody$Outbound;
};

/** @internal */
export const MintUserSessionRequest$outboundSchema: z.ZodMiniType<
  MintUserSessionRequest$Outbound,
  MintUserSessionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    mintUserSessionRequestBody: MintUserSessionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      mintUserSessionRequestBody: "MintUserSessionRequestBody",
    });
  }),
);

export function mintUserSessionRequestToJSON(
  mintUserSessionRequest: MintUserSessionRequest,
): string {
  return JSON.stringify(
    MintUserSessionRequest$outboundSchema.parse(mintUserSessionRequest),
  );
}
